import { render, staticRenderFns } from "./stock-exchange.vue?vue&type=template&id=08e3cf64&"
import script from "./stock-exchange.vue?vue&type=script&lang=js&"
export * from "./stock-exchange.vue?vue&type=script&lang=js&"
import style0 from "./stock-exchange.vue?vue&type=style&index=0&id=08e3cf64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports